import { type Face } from "../brep";
import type { Plane } from "../planeTypes";
import { trimFaceWithPlane } from "./trimFaceWithPlane";

export function trimFacesWithPlanes(faces: Face[], cutPlanes: Plane[]): Face[] {
  let result: Face[] = [...faces];

  for (const plane of cutPlanes) {
    const nextFaces: Face[] = [];

    for (const face of result) {
      const trimResult = trimFaceWithPlane(face, plane);
      nextFaces.push(...trimResult.faces);
    }

    result = nextFaces;
  }

  return result;
}
